import dayjs from "dayjs";
import { processDateJS } from "./dateProcessor";

function formatTimestamp(timestamp) {
  const date = new Date(timestamp._seconds * 1000); // Convert seconds to milliseconds
  return dayjs(date).format("DD/MM/YYYY HH:mm:ss"); // Format using dayjs
}

export function exportNotSubmittedReport(data, workbook) {
  const sheet = workbook?.addWorksheet("Full Report");
  const headerRow = sheet.addRow([
    "Group Name",
    "First period start",
    "First period end",
    "return isFinalised",
    "return isRevised",
    "return isSubmitted",
    "return type",
    "Group supervisors",
    "Group editors",
  ]);

  headerRow.eachCell((cell) => {
    cell.alignment = {
      wrapText: true,
      vertical: "middle",
      horizontal: "center",
    };
    cell.font = { bold: true };
  });

  sheet.autoFilter = {
    from: "A1",
    to: "J1",
  };

  for (let group of data) {
    const groupData = group?.data;
    let row = [];

    const firstPeriod = groupData?.periods_of_account?.[0] ?? {
      period_start: "",
      period_end: "",
      return_status: {
        isFinalised: "",
        isRevised: "",
        isSubmitted: "",
      },
    };

    const groupSupervisors =
      groupData?.users
        ?.filter((user) => user.role === "Supervisor")
        .map((user) => user.email)
        .join(", ") || "No supervisors";

    const groupEditors =
      groupData?.users
        ?.filter((user) => user.role === "Editor")
        .map((user) => user.email)
        .join(", ") || "No editors";

    row = [
      groupData?.group_name,
      firstPeriod?.period_start &&
        processDateJS(firstPeriod.period_start)?.format("DD/MM/YYYY"),
      firstPeriod?.period_end &&
        processDateJS(firstPeriod.period_end)?.format("DD/MM/YYYY"),
      firstPeriod?.return_status?.isFinalised,
      firstPeriod?.return_status?.isRevised,
      firstPeriod?.return_status?.isSubmitted,
      firstPeriod?.return_status?.type,
      groupSupervisors,
      groupEditors,
    ];

    sheet.addRow(row);

    (groupData?.periods_of_account &&
    Array.isArray(groupData.periods_of_account)
      ? groupData.periods_of_account.slice(1)
      : []
    ).forEach((period) => {
      sheet.addRow([
        groupData?.group_name,
        period?.period_start &&
          processDateJS(period.period_start)?.format("DD/MM/YYYY"),
        period?.period_end &&
          processDateJS(period.period_end)?.format("DD/MM/YYYY"),
        period?.return_status.isFinalised,
        period?.return_status.isRevised,
        period?.return_status.isSubmitted,
        period?.return_status?.type,
        groupSupervisors,
        groupEditors,
      ]);
    });
  }

  sheet.getColumn(1).width = 50;
  sheet.getCell("A1").font = { bold: true };

  sheet.getColumn(2).width = 12;
  sheet.getCell("B1").font = { bold: true };

  sheet.getColumn(3).width = 12;
  sheet.getCell("C1").font = { bold: true };

  sheet.getColumn(4).width = 12;
  sheet.getCell("D1").font = { bold: true };

  sheet.getColumn(5).width = 12;
  sheet.getCell("E1").font = { bold: true };

  sheet.getColumn(6).width = 12;
  sheet.getCell("F1").font = { bold: true };

  sheet.getColumn(7).width = 12;
  sheet.getCell("G1").font = { bold: true };

  sheet.getColumn(8).width = 30;
  sheet.getCell("H1").font = { bold: true };

  sheet.getColumn(9).width = 30;
  sheet.getCell("J1").font = { bold: true };

  return workbook;
}
